import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 12 12",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M9 2V0H1v12h8v-2H8v1H2V1h6v1z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8.293 3.293 7.586 4l1.5 1.5H5v1h4.086L7.586 8l.707.707L11 6z"
	})]
});
export default SvgLogout;
